// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"Testimonials_testimonials__BkVQr","container":"Testimonials_container__RBhqX","actionButtons":"Testimonials_actionButtons__VDOBQ"};